module.exports = __webpack_public_path__ + "assets/taozi.8a4f5aac.svg";